import { render, staticRenderFns } from "./ProviderZonesList.vue?vue&type=template&id=2882cb0b&scoped=true&"
import script from "./ProviderZonesList.vue?vue&type=script&lang=js&"
export * from "./ProviderZonesList.vue?vue&type=script&lang=js&"
import style0 from "./ProviderZonesList.vue?vue&type=style&index=0&id=2882cb0b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882cb0b",
  null
  
)

export default component.exports